module.exports = __webpack_public_path__ + "static/vertical-garden3-8831bf197a783095f3c9c68afec2cd8d.jpg";